import TableDefinitionListPage, {
  TABLE_DEFINITION_TYPE,
} from 'pages/SystemTenant/AROKMS/TableDefinition';

export default function TableDefinitionV2ListPage() {
  return <TableDefinitionListPage type={TABLE_DEFINITION_TYPE.TABLE_DEFINITION} version='v2' />;
}

